import { Button, CardContainer, Input } from '../../components'
import Table from '../../components/organisms/table'
import columns from './column'
import { Link } from 'react-router-dom';
import { ADDPARTPLANT } from '../../routes/routesNames';
import { UseGet } from '../../hooks/api';
import { UseTable } from '../../hooks';

const PartPlant = () => {    
    const {
        filter,
        isLoading,
        data,
        error,
        totalPages,
        handlePagination,
        handleLimit,
        handleFilter,
    } = UseGet('/v1/plantParts' )

    const {
        isLoading : isLoadingPost ,
        dataRemove,
        handleSelected,
        handleRemove
    } = UseTable();

  return (
      <CardContainer >
            <div className="d-flex flex-row justify-content-between">
                <Input type="search" id="search"  placeholder="Cari Bagian Tanaman" onChange={handleFilter} />
                {
                    dataRemove.length === 0  ? 
                    <div className="d-flex flex-row">          
                        <Link to={ADDPARTPLANT}>
                            <Button title="Tambah Bagian Tanaman" className="btn btn-primary" isSmall />                
                        </Link>
                    </div>
                    : 
                    <Button 
                        isLoading={isLoadingPost} 
                        onClick={() =>  handleRemove('/v1/plantParts/delete')}  
                        title="Hapus Bagian Tanaman" 
                        className="btn btn-danger" isSmall />     
                }
            </div>
            <Table 
                filter={filter}
                isLoading={isLoading}
                error={error}
                data={data}
                totalPages={totalPages}
                handlePagination={handlePagination}
                handleLimit={handleLimit}
                handleChangeSelect={handleSelected} 
                columns={columns}/>  
      </CardContainer>
  )
}

export default PartPlant